import { AppError, AppErrorType } from './app.model';

export class ApiStatusRange {

  public static readonly Success = new ApiStatusRange(200, 299);
  public static readonly Redirection = new ApiStatusRange(300, 399);
  public static readonly ClientError = new ApiStatusRange(400, 499);
  public static readonly ServerError = new ApiStatusRange(500, 599);

  constructor(minStatus: number, maxStatus: number) {
    this.minStatus = minStatus;
    this.maxStatus = maxStatus;
  }

  readonly minStatus: number;
  readonly maxStatus: number;

  public checkCode = (statusCode: number): boolean =>
    (statusCode >= this.minStatus && statusCode <= this.maxStatus)

}

export interface ResponseBody<Data> {
  data: Data;
  status: number;
  success: boolean;
}

export interface ErrorResponse {
  error: string;
  error_code: number;
}

const statusToAppErrorType = (status: number): AppErrorType => {
  if (ApiStatusRange.Success.checkCode(status)) {
    return AppErrorType.LOGICAL;
  } else if (ApiStatusRange.ClientError.checkCode(status)) {
    return AppErrorType.VALIDATION;
  } else if (ApiStatusRange.ServerError.checkCode(status)) {
    return AppErrorType.OUT_OF_SCOPE;
  }
  return AppErrorType.UNKNOWN;
};

export const createAppError = <Data>(response: ResponseBody<Data>): AppError<Data> => {
  const error = new Error(`An error occurred: status code: ${response.status} and body: ${response.data}`) as AppError<Data>;
  error.errorType = statusToAppErrorType(response.status);
  error.data = response.data;
  error.statusCode = response.status;
  error.rawResponse = response;
  return error;
};
